/*! nouislider - 8.2.1 - 2015-12-02 21:43:14 */

!function(a){"function"==typeof define&&define.amd?define([],a):"object"==typeof exports?module.exports=a():window.noUiSlider=a()}(function(){"use strict";function a(a){return a.filter(function(a){return this[a]?!1:this[a]=!0},{})}function b(a,b){return Math.round(a/b)*b}function c(a){var b=a.getBoundingClientRect(),c=a.ownerDocument,d=c.documentElement,e=m();return/webkit.*Chrome.*Mobile/i.test(navigator.userAgent)&&(e.x=0),{top:b.top+e.y-d.clientTop,left:b.left+e.x-d.clientLeft}}function d(a){return"number"==typeof a&&!isNaN(a)&&isFinite(a)}function e(a){var b=Math.pow(10,7);return Number((Math.round(a*b)/b).toFixed(7))}function f(a,b,c){j(a,b),setTimeout(function(){k(a,b)},c)}function g(a){return Math.max(Math.min(a,100),0)}function h(a){return Array.isArray(a)?a:[a]}function i(a){var b=a.split(".");return b.length>1?b[1].length:0}function j(a,b){a.classList?a.classList.add(b):a.className+=" "+b}function k(a,b){a.classList?a.classList.remove(b):a.className=a.className.replace(new RegExp("(^|\\b)"+b.split(" ").join("|")+"(\\b|$)","gi")," ")}function l(a,b){a.classList?a.classList.contains(b):new RegExp("(^| )"+b+"( |$)","gi").test(a.className)}function m(){var a=void 0!==window.pageXOffset,b="CSS1Compat"===(document.compatMode||""),c=a?window.pageXOffset:b?document.documentElement.scrollLeft:document.body.scrollLeft,d=a?window.pageYOffset:b?document.documentElement.scrollTop:document.body.scrollTop;return{x:c,y:d}}function n(a){a.stopPropagation()}function o(a){return function(b){return a+b}}function p(a,b){return 100/(b-a)}function q(a,b){return 100*b/(a[1]-a[0])}function r(a,b){return q(a,a[0]<0?b+Math.abs(a[0]):b-a[0])}function s(a,b){return b*(a[1]-a[0])/100+a[0]}function t(a,b){for(var c=1;a>=b[c];)c+=1;return c}function u(a,b,c){if(c>=a.slice(-1)[0])return 100;var d,e,f,g,h=t(c,a);return d=a[h-1],e=a[h],f=b[h-1],g=b[h],f+r([d,e],c)/p(f,g)}function v(a,b,c){if(c>=100)return a.slice(-1)[0];var d,e,f,g,h=t(c,b);return d=a[h-1],e=a[h],f=b[h-1],g=b[h],s([d,e],(c-f)*p(f,g))}function w(a,c,d,e){if(100===e)return e;var f,g,h=t(e,a);return d?(f=a[h-1],g=a[h],e-f>(g-f)/2?g:f):c[h-1]?a[h-1]+b(e-a[h-1],c[h-1]):e}function x(a,b,c){var e;if("number"==typeof b&&(b=[b]),"[object Array]"!==Object.prototype.toString.call(b))throw new Error("noUiSlider: 'range' contains invalid value.");if(e="min"===a?0:"max"===a?100:parseFloat(a),!d(e)||!d(b[0]))throw new Error("noUiSlider: 'range' value isn't numeric.");c.xPct.push(e),c.xVal.push(b[0]),e?c.xSteps.push(isNaN(b[1])?!1:b[1]):isNaN(b[1])||(c.xSteps[0]=b[1])}function y(a,b,c){return b?void(c.xSteps[a]=q([c.xVal[a],c.xVal[a+1]],b)/p(c.xPct[a],c.xPct[a+1])):!0}function z(a,b,c,d){this.xPct=[],this.xVal=[],this.xSteps=[d||!1],this.xNumSteps=[!1],this.snap=b,this.direction=c;var e,f=[];for(e in a)a.hasOwnProperty(e)&&f.push([a[e],e]);for(f.length&&"object"==typeof f[0][0]?f.sort(function(a,b){return a[0][0]-b[0][0]}):f.sort(function(a,b){return a[0]-b[0]}),e=0;e<f.length;e++)x(f[e][1],f[e][0],this);for(this.xNumSteps=this.xSteps.slice(0),e=0;e<this.xNumSteps.length;e++)y(e,this.xNumSteps[e],this)}function A(a,b){if(!d(b))throw new Error("noUiSlider: 'step' is not numeric.");a.singleStep=b}function B(a,b){if("object"!=typeof b||Array.isArray(b))throw new Error("noUiSlider: 'range' is not an object.");if(void 0===b.min||void 0===b.max)throw new Error("noUiSlider: Missing 'min' or 'max' in 'range'.");if(b.min===b.max)throw new Error("noUiSlider: 'range' 'min' and 'max' cannot be equal.");a.spectrum=new z(b,a.snap,a.dir,a.singleStep)}function C(a,b){if(b=h(b),!Array.isArray(b)||!b.length||b.length>2)throw new Error("noUiSlider: 'start' option is incorrect.");a.handles=b.length,a.start=b}function D(a,b){if(a.snap=b,"boolean"!=typeof b)throw new Error("noUiSlider: 'snap' option must be a boolean.")}function E(a,b){if(a.animate=b,"boolean"!=typeof b)throw new Error("noUiSlider: 'animate' option must be a boolean.")}function F(a,b){if("lower"===b&&1===a.handles)a.connect=1;else if("upper"===b&&1===a.handles)a.connect=2;else if(b===!0&&2===a.handles)a.connect=3;else{if(b!==!1)throw new Error("noUiSlider: 'connect' option doesn't match handle count.");a.connect=0}}function G(a,b){switch(b){case"horizontal":a.ort=0;break;case"vertical":a.ort=1;break;default:throw new Error("noUiSlider: 'orientation' option is invalid.")}}function H(a,b){if(!d(b))throw new Error("noUiSlider: 'margin' option must be numeric.");if(a.margin=a.spectrum.getMargin(b),!a.margin)throw new Error("noUiSlider: 'margin' option is only supported on linear sliders.")}function I(a,b){if(!d(b))throw new Error("noUiSlider: 'limit' option must be numeric.");if(a.limit=a.spectrum.getMargin(b),!a.limit)throw new Error("noUiSlider: 'limit' option is only supported on linear sliders.")}function J(a,b){switch(b){case"ltr":a.dir=0;break;case"rtl":a.dir=1,a.connect=[0,2,1,3][a.connect];break;default:throw new Error("noUiSlider: 'direction' option was not recognized.")}}function K(a,b){if("string"!=typeof b)throw new Error("noUiSlider: 'behaviour' must be a string containing options.");var c=b.indexOf("tap")>=0,d=b.indexOf("drag")>=0,e=b.indexOf("fixed")>=0,f=b.indexOf("snap")>=0,g=b.indexOf("hover")>=0;if(d&&!a.connect)throw new Error("noUiSlider: 'drag' behaviour must be used with 'connect': true.");a.events={tap:c||f,drag:d,fixed:e,snap:f,hover:g}}function L(a,b){var c;if(b!==!1)if(b===!0)for(a.tooltips=[],c=0;c<a.handles;c++)a.tooltips.push(!0);else{if(a.tooltips=h(b),a.tooltips.length!==a.handles)throw new Error("noUiSlider: must pass a formatter for all handles.");a.tooltips.forEach(function(a){if("boolean"!=typeof a&&("object"!=typeof a||"function"!=typeof a.to))throw new Error("noUiSlider: 'tooltips' must be passed a formatter or 'false'.")})}}function M(a,b){if(a.format=b,"function"==typeof b.to&&"function"==typeof b.from)return!0;throw new Error("noUiSlider: 'format' requires 'to' and 'from' methods.")}function N(a,b){if(void 0!==b&&"string"!=typeof b)throw new Error("noUiSlider: 'cssPrefix' must be a string.");a.cssPrefix=b}function O(a){var b,c={margin:0,limit:0,animate:!0,format:T};b={step:{r:!1,t:A},start:{r:!0,t:C},connect:{r:!0,t:F},direction:{r:!0,t:J},snap:{r:!1,t:D},animate:{r:!1,t:E},range:{r:!0,t:B},orientation:{r:!1,t:G},margin:{r:!1,t:H},limit:{r:!1,t:I},behaviour:{r:!0,t:K},format:{r:!1,t:M},tooltips:{r:!1,t:L},cssPrefix:{r:!1,t:N}};var d={connect:!1,direction:"ltr",behaviour:"tap",orientation:"horizontal"};return Object.keys(b).forEach(function(e){if(void 0===a[e]&&void 0===d[e]){if(b[e].r)throw new Error("noUiSlider: '"+e+"' is required.");return!0}b[e].t(c,void 0===a[e]?d[e]:a[e])}),c.pips=a.pips,c.style=c.ort?"top":"left",c}function P(b,d){function e(a,b,c){var d=a+b[0],e=a+b[1];return c?(0>d&&(e+=Math.abs(d)),e>100&&(d-=e-100),[g(d),g(e)]):[d,e]}function p(a,b){a.preventDefault();var c,d,e=0===a.type.indexOf("touch"),f=0===a.type.indexOf("mouse"),g=0===a.type.indexOf("pointer"),h=a;return 0===a.type.indexOf("MSPointer")&&(g=!0),e&&(c=a.changedTouches[0].pageX,d=a.changedTouches[0].pageY),b=b||m(),(f||g)&&(c=a.clientX+b.x,d=a.clientY+b.y),h.pageOffset=b,h.points=[c,d],h.cursor=f||g,h}function q(a,b){var c=document.createElement("div"),d=document.createElement("div"),e=["-lower","-upper"];return a&&e.reverse(),j(d,da[3]),j(d,da[3]+e[b]),j(c,da[2]),c.appendChild(d),c}function r(a,b,c){switch(a){case 1:j(b,da[7]),j(c[0],da[6]);break;case 3:j(c[1],da[6]);case 2:j(c[0],da[7]);case 0:j(b,da[6])}}function s(a,b,c){var d,e=[];for(d=0;a>d;d+=1)e.push(c.appendChild(q(b,d)));return e}function t(a,b,c){j(c,da[0]),j(c,da[8+a]),j(c,da[4+b]);var d=document.createElement("div");return j(d,da[1]),c.appendChild(d),d}function u(a,b){if(!d.tooltips[b])return!1;var c=document.createElement("div");return c.className=da[18],a.firstChild.appendChild(c)}function v(){d.dir&&d.tooltips.reverse();var a=Y.map(u);d.dir&&(a.reverse(),d.tooltips.reverse()),U("update",function(b,c,e){a[c]&&(a[c].innerHTML=d.tooltips[c]===!0?b[c]:d.tooltips[c].to(e[c]))})}function w(a,b,c){if("range"===a||"steps"===a)return aa.xVal;if("count"===a){var d,e=100/(b-1),f=0;for(b=[];(d=f++*e)<=100;)b.push(d);a="positions"}return"positions"===a?b.map(function(a){return aa.fromStepping(c?aa.getStep(a):a)}):"values"===a?c?b.map(function(a){return aa.fromStepping(aa.getStep(aa.toStepping(a)))}):b:void 0}function x(b,c,d){function e(a,b){return(a+b).toFixed(7)/1}var f=aa.direction,g={},h=aa.xVal[0],i=aa.xVal[aa.xVal.length-1],j=!1,k=!1,l=0;return aa.direction=0,d=a(d.slice().sort(function(a,b){return a-b})),d[0]!==h&&(d.unshift(h),j=!0),d[d.length-1]!==i&&(d.push(i),k=!0),d.forEach(function(a,f){var h,i,m,n,o,p,q,r,s,t,u=a,v=d[f+1];if("steps"===c&&(h=aa.xNumSteps[f]),h||(h=v-u),u!==!1&&void 0!==v)for(i=u;v>=i;i=e(i,h)){for(n=aa.toStepping(i),o=n-l,r=o/b,s=Math.round(r),t=o/s,m=1;s>=m;m+=1)p=l+m*t,g[p.toFixed(5)]=["x",0];q=d.indexOf(i)>-1?1:"steps"===c?2:0,!f&&j&&(q=0),i===v&&k||(g[n.toFixed(5)]=[i,q]),l=n}}),aa.direction=f,g}function y(a,b,c){function e(a){return["-normal","-large","-sub"][a]}function f(a,b,c){return'class="'+b+" "+b+"-"+h+" "+b+e(c[1])+'" style="'+d.style+": "+a+'%"'}function g(a,d){aa.direction&&(a=100-a),d[1]=d[1]&&b?b(d[0],d[1]):d[1],i.innerHTML+="<div "+f(a,da[21],d)+"></div>",d[1]&&(i.innerHTML+="<div "+f(a,da[22],d)+">"+c.to(d[0])+"</div>")}var h=["horizontal","vertical"][d.ort],i=document.createElement("div");return j(i,da[20]),j(i,da[20]+"-"+h),Object.keys(a).forEach(function(b){g(b,a[b])}),i}function z(a){var b=a.mode,c=a.density||1,d=a.filter||!1,e=a.values||!1,f=a.stepped||!1,g=w(b,e,f),h=x(c,b,g),i=a.format||{to:Math.round};return $.appendChild(y(h,d,i))}function A(){return X["offset"+["Width","Height"][d.ort]]}function B(a,b,c){void 0!==b&&1!==d.handles&&(b=Math.abs(b-d.dir)),Object.keys(ca).forEach(function(d){var e=d.split(".")[0];a===e&&ca[d].forEach(function(a){a.call(Z,h(P()),b,h(C(Array.prototype.slice.call(ba))),c||!1)})})}function C(a){return 1===a.length?a[0]:d.dir?a.reverse():a}function D(a,b,c,e){var f=function(b){return $.hasAttribute("disabled")?!1:l($,da[14])?!1:(b=p(b,e.pageOffset),a===R.start&&void 0!==b.buttons&&b.buttons>1?!1:e.hover&&b.buttons?!1:(b.calcPoint=b.points[d.ort],void c(b,e)))},g=[];return a.split(" ").forEach(function(a){b.addEventListener(a,f,!1),g.push([a,f])}),g}function E(a,b){if(-1===navigator.appVersion.indexOf("MSIE 9")&&0===a.buttons&&0!==b.buttonsProperty)return F(a,b);var c,d,f=b.handles||Y,g=!1,h=100*(a.calcPoint-b.start)/b.baseSize,i=f[0]===Y[0]?0:1;if(c=e(h,b.positions,f.length>1),g=L(f[0],c[i],1===f.length),f.length>1){if(g=L(f[1],c[i?0:1],!1)||g)for(d=0;d<b.handles.length;d++)B("slide",d)}else g&&B("slide",i)}function F(a,b){var c=X.querySelector("."+da[15]),d=b.handles[0]===Y[0]?0:1;null!==c&&k(c,da[15]),a.cursor&&(document.body.style.cursor="",document.body.removeEventListener("selectstart",document.body.noUiListener));var e=document.documentElement;e.noUiListeners.forEach(function(a){e.removeEventListener(a[0],a[1])}),k($,da[12]),B("set",d),B("change",d),void 0!==b.handleNumber&&B("end",b.handleNumber)}function G(a,b){"mouseout"===a.type&&"HTML"===a.target.nodeName&&null===a.relatedTarget&&F(a,b)}function H(a,b){var c=document.documentElement;if(1===b.handles.length&&(j(b.handles[0].children[0],da[15]),b.handles[0].hasAttribute("disabled")))return!1;a.preventDefault(),a.stopPropagation();var d=D(R.move,c,E,{start:a.calcPoint,baseSize:A(),pageOffset:a.pageOffset,handles:b.handles,handleNumber:b.handleNumber,buttonsProperty:a.buttons,positions:[_[0],_[Y.length-1]]}),e=D(R.end,c,F,{handles:b.handles,handleNumber:b.handleNumber}),f=D("mouseout",c,G,{handles:b.handles,handleNumber:b.handleNumber});if(c.noUiListeners=d.concat(e,f),a.cursor){document.body.style.cursor=getComputedStyle(a.target).cursor,Y.length>1&&j($,da[12]);var g=function(){return!1};document.body.noUiListener=g,document.body.addEventListener("selectstart",g,!1)}void 0!==b.handleNumber&&B("start",b.handleNumber)}function I(a){var b,e,g=a.calcPoint,h=0;return a.stopPropagation(),Y.forEach(function(a){h+=c(a)[d.style]}),b=h/2>g||1===Y.length?0:1,g-=c(X)[d.style],e=100*g/A(),d.events.snap||f($,da[14],300),Y[b].hasAttribute("disabled")?!1:(L(Y[b],e),B("slide",b,!0),B("set",b,!0),B("change",b,!0),void(d.events.snap&&H(a,{handles:[Y[b]]})))}function J(a){var b=a.calcPoint-c(X)[d.style],e=aa.getStep(100*b/A()),f=aa.fromStepping(e);Object.keys(ca).forEach(function(a){"hover"===a.split(".")[0]&&ca[a].forEach(function(a){a.call(Z,f)})})}function K(a){var b,c;if(!a.fixed)for(b=0;b<Y.length;b+=1)D(R.start,Y[b].children[0],H,{handles:[Y[b]],handleNumber:b});if(a.tap&&D(R.start,X,I,{handles:Y}),a.hover)for(D(R.move,X,J,{hover:!0}),b=0;b<Y.length;b+=1)["mousemove MSPointerMove pointermove"].forEach(function(a){Y[b].children[0].addEventListener(a,n,!1)});a.drag&&(c=[X.querySelector("."+da[7])],j(c[0],da[10]),a.fixed&&c.push(Y[c[0]===Y[0]?1:0].children[0]),c.forEach(function(a){D(R.start,a,H,{handles:Y})}))}function L(a,b,c){var e=a!==Y[0]?1:0,f=_[0]+d.margin,h=_[1]-d.margin,i=_[0]+d.limit,l=_[1]-d.limit;return Y.length>1&&(b=e?Math.max(b,f):Math.min(b,h)),c!==!1&&d.limit&&Y.length>1&&(b=e?Math.min(b,i):Math.max(b,l)),b=aa.getStep(b),b=g(parseFloat(b.toFixed(7))),b===_[e]?!1:(window.requestAnimationFrame?window.requestAnimationFrame(function(){a.style[d.style]=b+"%"}):a.style[d.style]=b+"%",a.previousSibling||(k(a,da[17]),b>50&&j(a,da[17])),_[e]=b,ba[e]=aa.fromStepping(b),B("update",e),!0)}function M(a,b){var c,e,f;for(d.limit&&(a+=1),c=0;a>c;c+=1)e=c%2,f=b[e],null!==f&&f!==!1&&("number"==typeof f&&(f=String(f)),f=d.format.from(f),(f===!1||isNaN(f)||L(Y[e],aa.toStepping(f),c===3-d.dir)===!1)&&B("update",e))}function N(a){var b,c,e=h(a);for(d.dir&&d.handles>1&&e.reverse(),d.animate&&-1!==_[0]&&f($,da[14],300),b=Y.length>1?3:1,1===e.length&&(b=1),M(b,e),c=0;c<Y.length;c++)B("set",c)}function P(){var a,b=[];for(a=0;a<d.handles;a+=1)b[a]=d.format.to(ba[a]);return C(b)}function Q(){da.forEach(function(a){a&&k($,a)}),$.innerHTML="",delete $.noUiSlider}function T(){var a=_.map(function(a,b){var c=aa.getApplicableStep(a),d=i(String(c[2])),e=ba[b],f=100===a?null:c[2],g=Number((e-c[2]).toFixed(d)),h=0===a?null:g>=c[1]?c[2]:c[0]||!1;return[h,f]});return C(a)}function U(a,b){ca[a]=ca[a]||[],ca[a].push(b),"update"===a.split(".")[0]&&Y.forEach(function(a,b){B("update",b)})}function V(a){var b=a.split(".")[0],c=a.substring(b.length);Object.keys(ca).forEach(function(a){var d=a.split(".")[0],e=a.substring(d.length);b&&b!==d||c&&c!==e||delete ca[a]})}function W(a){var b,c=P(),e=O({start:[0,0],margin:a.margin,limit:a.limit,step:a.step,range:a.range,animate:a.animate,snap:void 0===a.snap?d.snap:a.snap});for(["margin","limit","step","range","animate"].forEach(function(b){void 0!==a[b]&&(d[b]=a[b])}),aa=e.spectrum,_=[-1,-1],N(c),b=0;b<Y.length;b++)B("update",b)}var X,Y,Z,$=b,_=[-1,-1],aa=d.spectrum,ba=[],ca={},da=["target","base","origin","handle","horizontal","vertical","background","connect","ltr","rtl","draggable","","state-drag","","state-tap","active","","stacking","tooltip","","pips","marker","value"].map(o(d.cssPrefix||S));if($.noUiSlider)throw new Error("Slider was already initialized.");return X=t(d.dir,d.ort,$),Y=s(d.handles,d.dir,X),r(d.connect,$,Y),d.pips&&z(d.pips),d.tooltips&&v(),Z={destroy:Q,steps:T,on:U,off:V,get:P,set:N,updateOptions:W},K(d.events),Z}function Q(a,b){if(!a.nodeName)throw new Error("noUiSlider.create requires a single element.");var c=O(b,a),d=P(a,c);return d.set(c.start),a.noUiSlider=d,d}var R=window.navigator.pointerEnabled?{start:"pointerdown",move:"pointermove",end:"pointerup"}:window.navigator.msPointerEnabled?{start:"MSPointerDown",move:"MSPointerMove",end:"MSPointerUp"}:{start:"mousedown touchstart",move:"mousemove touchmove",end:"mouseup touchend"},S="noUi-";z.prototype.getMargin=function(a){return 2===this.xPct.length?q(this.xVal,a):!1},z.prototype.toStepping=function(a){return a=u(this.xVal,this.xPct,a),this.direction&&(a=100-a),a},z.prototype.fromStepping=function(a){return this.direction&&(a=100-a),e(v(this.xVal,this.xPct,a))},z.prototype.getStep=function(a){return this.direction&&(a=100-a),a=w(this.xPct,this.xSteps,this.snap,a),this.direction&&(a=100-a),a},z.prototype.getApplicableStep=function(a){var b=t(a,this.xPct),c=100===a?2:1;return[this.xNumSteps[b-2],this.xVal[b-c],this.xNumSteps[b-c]]},z.prototype.convert=function(a){return this.getStep(this.toStepping(a))};var T={to:function(a){return void 0!==a&&a.toFixed(2)},from:Number};return{create:Q}});


/**
 * Created by Chris on 7/6/2015.
 */

jQuery(document).ready(function($){

    $.ajax({
        url: '/minProductWidth',
        success: function (result) {
            $(document).data('minWidth', parseInt(result));
            $( "#min-width" ).val( parseInt(result) );
            $.ajax({
                url: '/maxProductWidth',
                success: function (result) {
                    $(document).data('maxWidth', parseInt(result));
                    $( "#max-width" ).val( parseInt(result) );

                    var slider = document.getElementById('width-slider');

                    noUiSlider.create(slider, {
                        start: [$(document).data('minWidth'), $(document).data('maxWidth')],
                        connect: true,
                        step: 1,
                        range: {
                            'min': $(document).data('minWidth'),
                            'max': $(document).data('maxWidth')
                        }
                    });

                    // When the slider value changes, update the input and span
                    slider.noUiSlider.on('update', function( values, handle ) {
                        console.log(values);
                        if ( handle ) {
                            console.log("handle " + values[1]);
                            $( "#max-width" ).val( values[1] );
                        } else {
                            console.log("not handle " + values[0]);
                            $( "#min-width" ).val( values[0] );
                        }
                        $( "#widths" ).val( parseInt(values[0]) + " in - " + parseInt(values[1]) + " in" );
                    });

                    // When the input changes, set the slider value
                    document.getElementById('min-width').addEventListener('change', function(){
                        slider.noUiSlider.set([null, this.value]);
                    });


                }
            });
        }
    });

    $.ajax({
        url: '/minProductHeight',
        success: function (result) {
            $(document).data('minHeight', parseInt(result));
            $( "#min-height" ).val( parseInt(result) );
            $.ajax({
                url: '/maxProductHeight',
                success: function (result) {
                    $(document).data('maxHeight', parseInt(result));
                    $( "#max-height" ).val( parseInt(result) );

                    var slider = document.getElementById('height-slider');

                    noUiSlider.create(slider, {
                        start: [$(document).data('minHeight'), $(document).data('maxHeight')],
                        connect: true,
                        step: 1,
                        range: {
                            'min': $(document).data('minHeight'),
                            'max': $(document).data('maxHeight')
                        }
                    });

                    // When the slider value changes, update the input and span
                    slider.noUiSlider.on('update', function( values, handle ) {
                        console.log(values);
                        if ( handle ) {
                            console.log("handle " + values[1]);
                            $( "#max-height" ).val( values[1] );
                        } else {
                            console.log("not handle " + values[0]);
                            $( "#min-height" ).val( values[0] );
                        }
                        $( "#heights" ).val( parseInt(values[0]) + " in - " + parseInt(values[1]) + " in" );
                    });

                    // When the input changes, set the slider value
                    document.getElementById('min-height').addEventListener('change', function(){
                        slider.noUiSlider.set([null, this.value]);
                    });


                }
            });
        }
    });

    $.ajax({
        url: '/minProductDepth',
        success: function (result) {
            $(document).data('minDepth', parseInt(result));
            $( "#min-depth" ).val( parseInt(result) );
            $.ajax({
                url: '/maxProductDepth',
                success: function (result) {
                    $(document).data('maxDepth', parseInt(result));
                    $( "#max-depth" ).val( parseInt(result) );

                    var slider = document.getElementById('depth-slider');

                    noUiSlider.create(slider, {
                        start: [$(document).data('minDepth'), $(document).data('maxDepth')],
                        connect: true,
                        step: 1,
                        range: {
                            'min': $(document).data('minDepth'),
                            'max': $(document).data('maxDepth')
                        }
                    });

                    // When the slider value changes, update the input and span
                    slider.noUiSlider.on('update', function( values, handle ) {
                        console.log(values);
                        if ( handle ) {
                            console.log("handle " + values[1]);
                            $( "#max-depth" ).val( values[1] );
                        } else {
                            console.log("not handle " + values[0]);
                            $( "#min-depth" ).val( values[0] );
                        }
                        $( "#depths" ).val( parseInt(values[0]) + " in - " + parseInt(values[1]) + " in" );
                    });

                    // When the input changes, set the slider value
                    document.getElementById('min-depth').addEventListener('change', function(){
                        slider.noUiSlider.set([null, this.value]);
                    });


                }
            });
        }
    });

    $.ajax({
        url: '/minProductDiameter',
        success: function (result) {
            $(document).data('minDiameter', parseInt(result));
            $( "#min-diameter" ).val( parseInt(result) );
            $.ajax({
                url: '/maxProductDiameter',
                success: function (result) {
                    $(document).data('maxDiameter', parseInt(result));
                    $( "#max-diameter" ).val( parseInt(result) );

                    var slider = document.getElementById('diameter-slider');

                    noUiSlider.create(slider, {
                        start: [$(document).data('minDiameter'), $(document).data('maxDiameter')],
                        connect: true,
                        step: 1,
                        range: {
                            'min': $(document).data('minDiameter'),
                            'max': $(document).data('maxDiameter')
                        }
                    });

                    // When the slider value changes, update the input and span
                    slider.noUiSlider.on('update', function( values, handle ) {
                        console.log(values);
                        if ( handle ) {
                            console.log("handle " + values[1]);
                            $( "#max-diameter" ).val( values[1] );
                        } else {
                            console.log("not handle " + values[0]);
                            $( "#min-diameter" ).val( values[0] );
                        }
                        $( "#diameters" ).val( parseInt(values[0]) + " in - " + parseInt(values[1]) + " in" );
                    });

                    // When the input changes, set the slider value
                    document.getElementById('min-diameter').addEventListener('change', function(){
                        slider.noUiSlider.set([null, this.value]);
                    });


                }
            });
        }
    });

    $('a#showsearch').click(function(e){
        e.preventDefault();
        $('#searchterm-div').toggle();
    });

    $('a.contactItem').on({
        click: function () {
            $('div.sendContactItem').slideToggle();
            $('div.sendEmailItem').slideUp();
        }
    });

    $('a.emailItem').on({
        click: function () {
            $('div.sendEmailItem').slideToggle();
            $('div.sendContactItem').slideUp();
        }
    });

    $('a#closeSentContact').on({
        click: function () {
            $("#contact-form-success").slideUp();
            $("#contact-form-failure").slideUp();
            $('div.sendContactItem').hide();
            $('div#contact-form-div').slideDown();
            $('div#contact-form-container').show();
        }
    });

    //$(".mix-preview").showLoading();

    $(".mix-preview").fancybox({
        maxWidth	: 640,
        maxHeight	: 800,
        fitToView	: true,
        width		: '80%',
        height		: '100%',
        autoSize	: true,
        autoCenter  : true,
        closeClick	: true,
        openEffect	: 'elastic',
        closeEffect	: 'none',
        arrows      : true,
        dataType    : 'html',
        headers     : { 'X-fancyBox': true }
    });

    $('a#sendAgainContact').on({
        click: function () {
            $("#contact-form-success").slideUp();
            $("#contact-form-failure").slideUp();
            $("div.sendContactItem").slideDown();
            $("div#contact-form-div").show();
            $("div#contact-form-container").show();
        }
    });

    function submitContactFormWithCaptchaResponse(event, token) {
        var url = "/products/contactform"; // the script where you handle the form input.

        $.ajax({
            type: "POST",
            url: url,
            data: $("#contact-form").serialize()+"&g-recaptcha-response="+token, // serializes the form's elements.
            beforeSend: function(event) {
                // User submitted the form
                $('body').css('cursor','wait');
                $("div#contact-form-container").slideUp();
            },
            success: function(data)
            {
                //$('div#contact-form form').find("input[type=text], textarea").val("");
                $("#contact-form")[0].reset()
                $("#contact-form-success").slideDown();
            },
            error: function(jqXHR, textStatus, errorMessage) {
                console.log(errorMessage); // Optional
                $("#contact-form-failure").slideDown();
            },
            complete: function() {
                $('body').css('cursor', 'default');

            }
        });
    }

    window.submitContactFormWithCaptchaResponse = submitContactFormWithCaptchaResponse;
    $('#submitcontactItem').on({
        click: function (event) {

            event.preventDefault();
            window.contactFormOnClick(event);
            return

        }
    });

    $('a#closeSentEmail').on({
        click: function () {
            $("#email-form-success").slideUp();
            $("#email-form-failure").slideUp();
            $('div.sendEmailItem').hide();
            $('div#email-form-div').slideDown();
            $('div#email-form-container').show();        }
    });

    $('a#sendAgainEmail').on({
        click: function () {
            $("#email-form-success").slideUp();
            $("#email-form-failure").slideUp();
            $("div.sendEmailItem").slideDown();
            $("div#email-form-div").show();
            $("div#email-form-container").show();
        }
    });

    // This function is called upon successful response from
    // Google captcha server, triggered by the onclick event below
    function submitEmailItemWithCaptchaResponse(event, token) {
        console.log("In submit email form with token function");
        var url = "/products/emailform"; // the script where you handle the form input.
        var desc = $('div.product-detail').html();

        $.ajax({
            type: "POST",
            url: url,
            data: $("#email-form").serialize()+ "&product_details="+desc+"&g-recaptcha-response="+token, // serializes the form's elements.
            beforeSend: function(event) {
                // User submitted the form
                $('body').css('cursor','wait');
                $("div#email-form-container").slideUp();
            },
            success: function(data)
            {
                $("#email-form")[0].reset()
                $("#email-form-success").slideDown();
            },
            error: function(jqXHR, textStatus, errorMessage) {
                console.log(errorMessage); // Optional
                $("#email-form-failure").slideDown();
            },
            complete: function() {
                $('body').css('cursor', 'default');

            }
        });
    }

    window.submitEmailItemWithCaptchaResponse = submitEmailItemWithCaptchaResponse;

    $('#submitemailItem').on({
        click: function (event) {
            event.preventDefault();
            window.emailFormOnClick(event);
            console.log("After calling onclick");
            return
        }
    });

    $('#smallImgs li').on({
        click: function (event) {
            event.preventDefault();
            var i = $('img', this).attr('src');
            $('a.cloud-zoom').attr("href", i);
            $('a.cloud-zoom img').attr('src', i);
            $('.cloud-zoom').CloudZoom();
        }
    });

    $('#useadvsearch').on({
        click: function (event) {
            event.preventDefault();
            if( $("#advsearchterm-div").is(":visible") ) {
                $("#advsearchterm-div").slideUp();
                $("#useadvsearch").text("use advanced search");
            } else {
                $("#advsearchterm-div").slideDown();
                $("#useadvsearch").text("hide advanced search");
            }

        }
    });

    $('#toggleadvsearch').on({
        click: function (event) {
            event.preventDefault();

            if( $("#advsearchterm-div").is(":visible") ) {
                $("#advsearchterm-div").slideUp();
                $("#minisearchterm-div").slideDown();
                $("#useadvsearch").text("use advanced search");
            } else {
                $("#advsearchterm-div").slideDown();
                $("#minisearchterm-div").slideUp();
                $("#useadvsearch").text("hide advanced search");
            }

        }
    });
    $('.toggleadvsearch').on({
        click: function (event) {
            event.preventDefault();

            if( $("#advsearchterm-div").is(":visible") ) {
                $("#advsearchterm-div").slideUp();
                $("#minisearchterm-div").slideDown();
                $("#useadvsearch").text("use advanced search");
            } else {
                $("#advsearchterm-div").slideDown();
                $("#minisearchterm-div").slideUp();
                $("#useadvsearch").text("hide advanced search");
            }

        }
    });

    $('#hide_advsearchterm').on({
        click: function (event) {
            event.preventDefault();

            $("#advsearchterm-div").slideUp();
            $("#useadvsearch").text("use advanced search");

        }
    });

    $('#submit_minisearchterm').on({
        click: function (event) {
            event.preventDefault();

            if ($('#searchterm').val()=="") {
                //alert("You must enter some search criteria.");
                $("#searchterm").addClass('search-alert');
                $("#searchterm").attr("placeholder", "You must enter search criteria.");
            } else {
                $('#search-form').submit();
            }



        }
    });

    $('#submit_advsearchterm').on({
        click: function (event) {
            event.preventDefault();

            if (
                $('#searchterm').val()=="" &&
                $('#item_number').val()=="" &&
                $('#width').val()=="" &&
                $('#min-width').val()=="" &&
                $('#max-width').val()=="" &&
                $('#height').val()=="" &&
                $('#min-height').val()=="" &&
                $('#max-height').val()=="" &&
                $('#depth').val()=="" &&
                $('#min-depth').val()=="" &&
                $('#max-depth').val()=="" &&
                $('#diameter').val()=="" &&
                $('#min-diameter').val()=="" &&
                $('#max-diameter').val()=="" &&
                $('#origin').val()=="" &&
                $('#circa').val()=="" &&
                $('#capacity').val()=="" &&
                $('#materials').val()=="" &&
                $('#creator').val()=="" &&
                $('#manufacturer').val()==""
            ) {
                alert("You must make choose some search criteria.");
            } else {
                $('#adv-search-form').submit();
            }

        }
    });


})